import { ORGX_HOSTED_MCP_HEALTH_URL } from "../constants.js";

export interface HostedMcpHealthCheck {
  ok: boolean;
  skipped: boolean;
  status?: number;
  url: string;
  body?: string;
  error?: string;
  details: string[];
}

function trimBody(value: string): string | undefined {
  const next = value.trim();
  if (!next) return undefined;
  return next.length > 120 ? `${next.slice(0, 117)}...` : next;
}

export async function checkHostedMcpHealth(): Promise<HostedMcpHealthCheck> {
  try {
    const response = await fetch(ORGX_HOSTED_MCP_HEALTH_URL, {
      method: "GET",
      signal: AbortSignal.timeout(5_000),
    });
    const text = await response.text();
    const body = trimBody(text);

    return {
      ok: response.ok,
      skipped: false,
      status: response.status,
      url: ORGX_HOSTED_MCP_HEALTH_URL,
      ...(body ? { body } : {}),
      ...(response.ok ? {} : { error: `HTTP ${response.status}` }),
      details: [
        `http status: ${response.status}`,
        ...(body ? [`body: ${body}`] : []),
      ],
    };
  } catch (error) {
    return {
      ok: false,
      skipped: false,
      url: ORGX_HOSTED_MCP_HEALTH_URL,
      error: error instanceof Error ? error.message : String(error),
      details: [],
    };
  }
}
